<template>
  <div class="container">
      <!-- 面包屑导航 -->
      <div class="content" v-loading="loading">
        <div class="form-search">
          <div class="label">搜索</div>
          <el-input placeholder="请输入搜索内容" suffix-icon="el-icon-search" v-model="keyword" size="small" class="search-input" @keyup.enter.native="fetchData"></el-input>
          <el-button type="primary" size="small" class="btn" @click="fetchData">查询</el-button>
          <el-button type="primary" size="small" plain @click="fetchData('reset')">重置</el-button>
        </div>
        <template v-if="total > 0">
          <div v-for="(item,index) in list" :key="index" >
            <dl class="list-dl" v-if="item.count>0" >
              <dt class="list-dt">{{item.groupName}}({{item.count}})</dt>
              <dd class="list-dd" v-for="(item2,index2) in item.templates" :key="index2" @click="()=>{$router.push({name:'sendApproval',query:{id:item2.id}})}">
                <div class="name ">
                  <i class="icon" />
                  <div class="ellipsis2" :title="item2.templateName">{{item2.templateName}}</div>
                </div>
              </dd>
            </dl>
          </div>
        </template>
        <div class="no-data-container" v-else-if="total === 0">
          <div class="no-data" >
            <img src="@/assets/img/img_wushuju.png" alt=""></img>
            <div class="text">暂无数据</div>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
export default {
  name: 'sendApprovalList',
  components: {
  },
  data() {
      return {
          keyword:'',
          list:[],
          total:-1,
          loading: false
      }
  },
  created() {
      
  },
  activated() {
      this.fetchData()
  },
  mounted() {

  },
  methods: {
     
      // 列表
      fetchData(type) {
        if(type === 'reset'){
          this.keyword = ''
        }
        const postData = {
          queryStr:this.keyword
        }
          this.loading = true
          this.$api.workflowAvailable(postData).then((res) => {
              if (res.code == 0) {
                let list = res.data
                let total = 0
                list.forEach(e => {
                    e.count = e.templates.length
                    total +=  e.count
                })
                this.list = list
                this.total = total
              } else {
                  this.$message.error(res.message)
                  this.total = 0
              }
              this.loading = false
          }).catch(error => {
              this.loading = false
              this.total = 0
          })
      },

  }
}
</script>

<style scoped lang="scss">
.container {
    width: 100%;
    height: 100%;

    .content {
        width: 100%;
        min-height: calc(100vh - 118px);
        margin-top: 16px;
        background-color: white;
        padding-left: 16px;
        padding-right: 16px;
        padding-top: 26px;
        box-sizing: border-box;
        padding-bottom: 32px;
        border-bottom: 32px solid #F5FAF9;
        border-radius: 8px 8px 8px 8px / 8px 8px 40px 40px;
    }
    .form-search{
      padding-top:10px;
      display: flex;
      border-bottom: 1px solid #EDF2F2;
      padding-bottom: 20px;
      .label{
        width: 36px;
        flex-shrink: 0;
        font-size: 14px;
        color: #2F3030;
        line-height: 32px;
      }
      .search-input{
        width: 204px;
        margin-right: 32px;
      }
      .btn{
        margin-right: 2px;
      }
    }
    .list-dl{
      margin-left:-24px;
      .list-dt{
        height:70px;
        box-sizing: border-box;
        padding: 31px 0 0 6px;
        font-weight: bold;
        font-size: 16px;
        color: #2F3030;
        position: relative;
        margin-left: 24px;
        &:after{
          content: '';
          position: absolute;
          left: 0;
          top:35px;
          width: 2px;
          height: 16px;
          background: #00B498 ;
        }
      }
      .list-dd{
        display: inline-flex;
        width: 256px;
        height: 64px;
        background: #FFFFFF;
        border-radius: 4px;
        border: 1px solid #E3E6E5;
        margin-bottom:16px;
        box-sizing: border-box;
        padding-left:12px;
        line-height: 32px;
        cursor: pointer;
        margin-left:24px;
      }
      .name{
        display: inline-flex;
        align-items: center;
        color: #2F3030;
        font-size: 14px;
        line-height: 1.2;
      }
      .icon{
        display: inline-block;
        width: 32px;
        height: 32px;
        background-image:url('~@/assets/img/icon/icon-shenpi.png');
        margin-right: 8px;
        flex-shrink: 0;
      }
    }
    .no-data-container{
      display: flex;
      min-height: calc(100vh - 300px);
    }
}

</style>
